import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class TbillBillServiceService {
  tbillBillService: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'tbill_service/list/?';
  private AddRecord = webapi + 'tbill_service/create';
  private CloseBill = webapi + 'tbill_charges_services/closeIpdBill/?';
  private AddIPDRecord = webapi + 'tbill_charges_services/create';
  private EditRecord = webapi + 'tbill_service/update';
  private EditRecordList = webapi + 'tbill_service/updatelist';
  private EditIPDchargeRecordList = webapi + 'tbill_charges_services/updatelist';
  private ModifyIPDchargeRecordList = webapi + 'tbill_charges_services/modifyRates';
  private GetRecord = webapi + 'tbill_service/byid/';
  private DeleteRecord = webapi + 'tbill_bill_service/delete/';
  private GetTbillBillServiceByBsId = webapi + 'tbill_service/byid/';
  private DeleteTbillServiceServiceRecord = webapi + 'tbill_service/delete/';
  private Gettokenbydepartment = webapi + 'tbill_service/gettokenbydepartment?';
  private ListRecordByBill = webapi + 'tbill_service/listbybill/';
  private GtBillservicelistbybillId = webapi + 'tbill_service/getBillservicelistbybillId/';
  private ListRecordByBillId = webapi + 'tbill_service/listbybillId/?';
  private Gettokenbystaff = webapi + 'tbill_service/gettokendisplaybystaff/?';
  private FindPreviousPatient = webapi + 'tbill_service/findPreviousPatient/';
  private GetAlltokenbystaff = webapi + 'tbill_service/getalltokendisplaybystaff/?';
  private FindNextPatient = webapi + 'tbill_service/findnextpatient/';
  private CloseVisit = webapi + 'tbill_service/endvisit/';
  private GetCancelList = webapi + 'tbill_service/listbytbrId/';
  private EditVisitTimeAndCallPatient = webapi + 'tbill_service/editVisitTimeAndCallPatient/';
  private GetBillByBillIdPage = webapi + 'tbill_service/listbyBillIdPage/?';
  private getGroupDisBillId = webapi + 'groupwisediscount/getByBillId/';
  private PatientsLastFirstVisitDateBillService = webapi + 'tbill_service/getPatientsLastFirstVisitDateBillService/?';

  constructor(
    private http: Http
  ) {
  }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addRecordService(model: any) {
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  addRecordIPDService(model: any) {
    return this.http.post(this.AddIPDRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }
  closeIPDBillService(ipdchargeId: number){
    return this.http.get(this.CloseBill + status + '/' + ipdchargeId)
        .toPromise()
        .then(response => response.json())
        .catch(this.handleError);
  }
  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordServiceList(model: any) {
    return this.http.put(this.EditRecordList, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordServicechargeList(model: any) {
    return this.http.put(this.EditIPDchargeRecordList, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }
  modifyRecordServicechargeList(model: any) {
    return this.http.put(this.ModifyIPDchargeRecordList , JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  closevisitService(status: any, billserviceid: any) {
    return this.http.get(this.CloseVisit + status + '/' + billserviceid)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  } getTbillBillServiceByBsId (id: any) {
    return this.http.put(this.GetTbillBillServiceByBsId  + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteTbillServiceServiceRecord(id: any) {
    return this.http.put(this.DeleteTbillServiceServiceRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordByBill(billId: any) {
    console.log(billId)
      console.log(this.ListRecordByBill)
    return this.http.get(this.ListRecordByBill + billId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getBillservicelistbybillId (billId: any) {
    return this.http.get(this.GtBillservicelistbybillId  + billId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getTokenByDepartment(dept: any, currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.Gettokenbydepartment + 'dept=' + dept + '&page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }
    getListRecordByBillId(currentPage: any, size: any, qString: any, sort: any, col: any,billId: any): Promise<any> {
    return this.http.get(this.ListRecordByBillId + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col+ '&billId=' + billId)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getTokenByStaff(staffid: any, currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.Gettokenbystaff + 'staffid=' + staffid + '&page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  findPreviousPatient(id: any) {
    return this.http.get(this.FindPreviousPatient + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllTokenByStaff(staffid: any): Promise<any> {
    return this.http.get(this.GetAlltokenbystaff + 'staffid=' + staffid)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  findNextPatient(id: any) {
    return this.http.get(this.FindNextPatient + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }

  getListOfCancelledItems(id: any) {
    return this.http.get(this.GetCancelList + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editVisitTimeAndCallPatient(status: any, billserviceid: any) {
    return this.http.get(this.EditVisitTimeAndCallPatient + status + '/' + billserviceid)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecordByBillIdPageService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.GetBillByBillIdPage + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

    getGroupWiseDiscountByBillId(billId: any){
        return this.http.post( this.getGroupDisBillId + "?billId=" + billId, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getPatientsLastFirstVisitDateBillService(patientId: any): Promise<any> {
        return this.http.get(this.PatientsLastFirstVisitDateBillService + 'patientId=' + patientId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/billing/tbill-bill-service/tbill-bill-service.service.ts